import Swal from "sweetalert2";

export const SwalConfirm = {
    leavePage: (url, title = 'Are you sure?', message = "You won't be able to revert this!", confirmText = "Yes", icon = "warning") => {
        return Swal.fire({
            title: title,
            text: message,
            icon: icon,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmText
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = url;
            }
        })
    }
}